// Grouping of prompt fields by show_to_user for the call channel: fields shown
// to agents are processed immediately at call end and appear in the desktop
// app; the rest are processed later. Only the call channel honors the flag.
export const FIELD_GROUP = {
  SHOWN_TO_AGENT: 'shown-to-agent',
  PROCESSED_LATER: 'processed-later',
}

// Splits prompt_fields into the two visibility groups while preserving each
// field's original array index, which formik Field bindings key off of.
export const partitionFieldsByAgentVisibility = (promptFields) => {
  const withIndex = promptFields.map((field, index) => ({ field, index }))

  return {
    [FIELD_GROUP.SHOWN_TO_AGENT]: withIndex.filter(({ field }) => field.show_to_user === true),
    [FIELD_GROUP.PROCESSED_LATER]: withIndex.filter(({ field }) => field.show_to_user !== true),
  }
}

// Appends a field and returns the flat prompt_fields with agent-visible fields
// first, so a new field's order_id (its array index at save/test) matches the
// grouped order the user sees — otherwise a new "shown to agent" field lands
// after the processed-later fields and sorts to the end of the results.
export const appendFieldInVisibilityOrder = (promptFields, newField) => {
  const withNew = [...promptFields, newField]
  return [
    ...withNew.filter((field) => field.show_to_user === true),
    ...withNew.filter((field) => field.show_to_user !== true),
  ]
}

// Applies a drag result across the visibility groups and returns the new flat
// prompt_fields array, agent-visible fields first. Moving a field across
// groups flips its show_to_user.
export const moveFieldBetweenVisibilityGroups = (promptFields, source, destination) => {
  const partitioned = partitionFieldsByAgentVisibility(promptFields)
  const groups = {
    [FIELD_GROUP.SHOWN_TO_AGENT]: partitioned[FIELD_GROUP.SHOWN_TO_AGENT].map(({ field }) => field),
    [FIELD_GROUP.PROCESSED_LATER]: partitioned[FIELD_GROUP.PROCESSED_LATER].map(
      ({ field }) => field
    ),
  }

  const [moved] = groups[source.droppableId].splice(source.index, 1)
  groups[destination.droppableId].splice(destination.index, 0, {
    ...moved,
    show_to_user: destination.droppableId === FIELD_GROUP.SHOWN_TO_AGENT,
  })

  return [...groups[FIELD_GROUP.SHOWN_TO_AGENT], ...groups[FIELD_GROUP.PROCESSED_LATER]]
}
